export default __webpack_public_path__ + "static/media/sort.8fef3182.svg";